import { CHART_COLORS } from "../styles/theme";

/* Palette de repli si l'API ne fournit pas de couleur pour une catégorie */
const FALLBACK_PALETTE = [
    CHART_COLORS.violet,
    CHART_COLORS.blue,
    CHART_COLORS.violetMid,
    CHART_COLORS.violetSoft,
    CHART_COLORS.grey,
    CHART_COLORS.blueSoft,
];

/**
 * Transforme la réponse de GET /hr/pilotage/frais en modèle
 * consommé par FraisSection.
 */
export const mapFrais = (api) => ({
    total: api.total_amount ?? 0,
    devise: api.currency ?? "CHF",
    categories: (api.by_category ?? []).map((c, i) => ({
        name: c.category_name,
        amount: c.amount ?? 0,
        pct: c.pct ?? 0,
        color: c.color || FALLBACK_PALETTE[i % FALLBACK_PALETTE.length],
    })),
});
